export const langSession = {
  fr: {
    sessionsLink: 'Sessions',
    sourceFile: `Source : `,
    speedChartTitle: 'Vitesse instantanée',
    speedChartY: 'knt',
    sessionStatsLink: 'Détails session',
    sessionsButton: `Sessions`,
    pathButton: 'Voir parcours',
    gpsButton: 'Ajuster données GPS',
    rigButton: 'Matériel utilisé',
    meteoButton: 'Données Vent',
    rigsAlert:
      'Pour saisir des équipements pour une session, il faut commencer par ajouter des boards et des sails / wings',
    help: [
      `Utilisez les boutons situés en bas de l'écran :`,
      `Cliquez sur 'Voir parcours' pour visualiser la trace GPS de la session sur carte.`,
      `Cliquez sur 'Ajuster données gps' pour exclure des parties du parcours du calcul des stats.`,
      `Cliquez sur 'Matériel utilisé' pour indiquer quelles ailes, voiles et boards vous avez utilisé pendant la session et les voir figurer dans le graphe des vitesses.`,
      `Cliquez sur 'Données vent' pour associer des données météo à la session.`,
      `Dans la liste des 5 Vitesses Max, cliquez sur une des lignes pour afficher sa position dans le graphe des vitesses. Les 3 premières vitesses max sont déjà repérées par un point rouge.`,
    ],
    statsLink: `Stats`,
    pathLink: `Parcours`,
    gpsLink: `Données GPS`,
    rigsLink: `Gréements`,
    meteoLink: `Météo`,
  },

  eng: {
    sessionsLink: 'Sessions',
    sourceFile: `Source : `,
    speedChartTitle: 'Current speed',
    speedChartY: 'knt',
    sessionStatsLink: 'Session details',
    sessionsButton: `Sessions`,
    pathButton: 'View path',
    gpsButton: 'Set GPS data',
    rigButton: 'Equipment used',
    meteoButton: 'Wind data',
    rigsAlert:
      'To enter equipments for a session, you must first add boards and sails / wings',
    help: [
      `Click on the 'View path' button to view the GPS trace of the session on map.`,
      `Click 'Set gps data' to exclude parts of the route from the stats calculation.`,
      `Click 'Equipment used' to indicate which wings, sails and boards you used during the session`,
      `Click 'Wind Data' to associate weather data to the session`,
      `In the list of 5 Max Speeds, click one of the lines to display its position in the speed graph. The first 3 max speeds are already marked by a red dot.`,
    ],
    statsLink: `Stats`,
    pathLink: `Path`,
    gpsLink: `GPS data`,
    rigsLink: `Rigs`,
    meteoLink: `Meteo`,
  },
}
